"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Summer_1 = __importDefault(require("./Summer"));
var Winter_1 = __importDefault(require("./Winter"));
var Spring_1 = __importDefault(require("./Spring"));
var Autumn_1 = __importDefault(require("./Autumn"));
var styled_1 = require("./styled");
var Season = function (_a) {
    var children = _a.children, _b = _a.type, type = _b === void 0 ? "auto" : _b;
    var _c = (0, react_1.useState)(type), seasonType = _c[0], setSeasonType = _c[1];
    var getSeason = function () {
        var mon = new Date().getMonth() + 1;
        if (3 <= mon && mon <= 5) {
            setSeasonType("spring");
            return "spring";
        }
        else if (6 <= mon && mon <= 8) {
            setSeasonType("summer");
            return "summer";
        }
        else if (9 <= mon && mon <= 11) {
            setSeasonType("autumn");
            return "autumn";
        }
        else {
            setSeasonType("winter");
            return "winter";
        }
    };
    var handleSeasonType = function (type) {
        if (type === "auto") {
            type = getSeason();
        }
        switch (type) {
            case "spring":
                return react_1.default.createElement(Spring_1.default, { type: "spring" });
            case "summer":
                return react_1.default.createElement(Summer_1.default, { type: "summer" });
            case "autumn":
                return react_1.default.createElement(Autumn_1.default, { type: "autumn" });
            case "winter":
                return react_1.default.createElement(Winter_1.default, { type: "winter" });
        }
    };
    (0, react_1.useEffect)(function () {
        if (type === "auto") {
            setSeasonType(getSeason());
        }
        else {
            setSeasonType(type);
        }
    }, [type]);
    return (react_1.default.createElement(styled_1.SeasonContainer, { type: seasonType },
        handleSeasonType(seasonType),
        react_1.default.createElement("div", null, children)));
};
exports.default = Season;
